import { Observable } from "rxjs";
import { CommonHttpOption } from "./../../base/common-http-option";
import { ServiceRoute } from "src/app/services/http/base/service-route";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";

@Injectable({
  providedIn: 'root'
})
export class InvoiceRejectService {

  constructor(private core: CoreService) { }

  returnInvoice(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.invoceReject.returnInvoice,
      data,
      new CommonHttpOption().headers
    );
  }

  payPayingPerson(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.invoceReject.payPayingPerson,
      data,
      new CommonHttpOption().headers
    );
  }
  payToWalletPerson(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.invoceReject.payToWalletPerson,
      data,
      new CommonHttpOption().headers
    );
  }

  invoiceRejectCauseCombo(): Observable<any> {
    return this.core.get(
      ServiceRoute.invoceReject.invoiceRejectCauseCombo,
      new CommonHttpOption().headers
    );
  }

  returnCalculation(id: number): Observable<any> {
    let data = {
      Id: id
    };
    return this.core.post(
      ServiceRoute.invoceReject.returnCalculation,
      data,
      new CommonHttpOption().headers
    );
  }
}
